module.exports = MaterialUI.IconButton;